// Angular + External
import { Injectable, OnDestroy } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { Router } from "@angular/router";
// BFX
import { BfxAuthService } from "./bfx-auth.service";
import { User } from "../models/user.model";
import {
  AccountPromiseLookupService, // accounts
  CcyPromiseLookupService, // currencies
  CcyPairPromiseLookupService, // currency pairs
  TraderGroupPromiseLookupService, // trader groups
  SalesGroupPromiseLookupService, // sales groups
  OrderDataPromiseLookupService, // orders data
  //  QuotePromiseLookupService , // quotes
  ClientPromiseLookupService, // clients
  SystemConfigPromiseService,
  BranchPromiseLookupService,
  BenchmarkDataPrimaryLookupService,
} from "shared/cubiq-services";
import { BfxTradeActionsService } from "../../bfx-blotter-trade/services/bfx-trade-actions.service";
import { BfxConfigService } from "../../../shared/auth-services/system-config/bfx-config.service";
// import { BfxBlotterQuotesService } from "../../bfx-blotter-quotes/bfx-blotter-quotes.service";
import { BfxBlotterOrdersService } from "../../bfx-blotter-orders/bfx-blotter-orders.service";
import { BfxTradeBlotterService } from "../../bfx-blotter-trade/services/bfx-trade-blotter.service";
import { BfxInterventionBlotterService } from "../../bfx-blotter-intervention/services/bfx-intervention-blotter.service";
import { BfxBlotterOrdersActionService } from "../../bfx-blotter-orders/bfx-blotter-orders-action.service";
import { BfxBmarkClientOrdersBlotterActionsService } from "../../bfx-bmark-summary/blotters/client-orders/services/bmark-client-orders-actions.service";
import { BfxBmarkHedgeOrdersBlotterActionsService } from "../../bfx-bmark-summary/blotters/hedge-orders/services/bmark-hedge-orders-actions.service";
// import { BfxBlotterQuotesActionService } from "../../bfx-blotter-quotes/bfx-blotter-quotes-action.service";
import { BfxBlotterInboxService } from "../../bfx-blotter-inbox/bfx-blotter-inbox.service";
import { BfxBlotterInboxFilter } from "../../bfx-blotter-inbox/bfx-blotter-inbox-filter";
import { RatePromiseService } from "shared/cubiq-services/rate/impl/RatePromiseService";
import { BfxScratchPadService } from "../../bfx-blotter-scratchpad/services/bfx-scratchpad.service";
import { TranslateService } from "@ngx-translate/core";

import { PromiseSet, PrimaryPromiseSet } from "shared/cubiq-services";
import { BfxConnectionMonitorService } from "app/bfx-connection-monitor/bfx-connection-monitor.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);
const ASYNC_PRIME_KEY = "async.prime.i18n";
const ASYNC_PRIME_VALUE = "async.prime.i18n.ok";

@Injectable()
export class BfxPrimeService implements OnDestroy {
  private configurationSubscription: Subscription;
  private hmrPrimeSubscription: Subscription;

  public config: any = {
    debug: true,
  };
  private primed: boolean = false;
  private waitPrimedSet: PromiseSet<boolean> = new PrimaryPromiseSet<boolean>();

  // command channel
  private _primeControlSource = new Subject<{ cmd: string; payload: any }>();
  public primeControl$ = this._primeControlSource.asObservable();

  public user: User = new User("", "");

  public progress = {
    error: 0,
    primed: 0,
    skipped: 0,
    total: null,
  };

  constructor(
    private _authService: BfxAuthService,
    private _configService: BfxConfigService,
    private _cubiqAccountService: AccountPromiseLookupService,
    private _branchService: BranchPromiseLookupService,
    private _cubiqCcyService: CcyPromiseLookupService,
    private _cubiqCcyPairService: CcyPairPromiseLookupService,
    private _cubiqTraderGroupService: TraderGroupPromiseLookupService, // trader groups
    private _cubiqSalesGroupService: SalesGroupPromiseLookupService, // sales groups
    private _cubiqOrderDataService: OrderDataPromiseLookupService, // orders data
    // private _cubiqQuoteLookupService: QuotePromiseLookupService, // orders data
    private _cubiqClientService: ClientPromiseLookupService, // clients
    private _ordersActionService: BfxBlotterOrdersActionService, // blotter orders action service
    private _bmarkClientOrdersActionService: BfxBmarkClientOrdersBlotterActionsService, // bmark summary orders action service
    private _bmarkHedgeOrdersActionService: BfxBmarkHedgeOrdersBlotterActionsService, // bmark summary orders action service
    // private _quotesActionService: BfxBlotterQuotesActionService, // blotter quotes action service
    private _tradeActionsService: BfxTradeActionsService, // trade action service
    // private _blotterQuoteService:BfxBlotterQuotesService,
    private _blotterOrdersService: BfxBlotterOrdersService,
    private _tradeBlotterService: BfxTradeBlotterService,
    private _interventionBlotterService: BfxInterventionBlotterService,
    private _inboxBlotterService: BfxBlotterInboxService,
    private _inboxFilter: BfxBlotterInboxFilter,
    private _rateService: RatePromiseService,
    private _systemConfigService: SystemConfigPromiseService,
    private _scratchPadOrdersService: BfxScratchPadService,
    private _translateService: TranslateService,
    private _router: Router,
    private _benchmarkLookupService: BenchmarkDataPrimaryLookupService,
    private _connectionMonitorService: BfxConnectionMonitorService,
  ) {
    this.subscribeToConfiguration();

    this.hmrPrimeSubscription = this._authService.hmrPrime$.subscribe({
      next: () => {
        logger.out.info(`${this.constructor.name} HMR invoked prime`);
        this.prime().then(() => {
          logger.out.info(`${this.constructor.name} HMR invoked prime complete`);
        });
      },
    });
  }

  ngOnDestroy() {
    if (this.configurationSubscription != null) {
      this.configurationSubscription.unsubscribe();
    }

    if (this.hmrPrimeSubscription != null) {
      this.hmrPrimeSubscription.unsubscribe();
    }
  }
  /**********************************************************************/
  /* INITIALIZATION */
  private subscribeToConfiguration(): void {
    this.configurationSubscription = this._configService.uiConfig$.subscribe(
      (config) => {
        this.config.debug = config.general.debug;
      },
      (reject) => {
        logger.out.error(
          "ERROR: LoaderComponent.subscribeToConfiguration(): configuration load fail | err:",
          reject,
        );
      },
    );
  }

  /**********************************************************************/
  /* PUBLIC METHODS */
  public isPrimed(): boolean {
    return this.primed;
  }

  public prime(): Promise<boolean> {
    logger.out.info("PrimeService prime() activated!");
    if (!this._authService.isAuthenticated()) {
      // if not logged in
      return new Promise((resolve) => {
        resolve(false);
      });
    } else {
      return new Promise((resolve, reject) => {
        try {
          this.prepareServicePromises().then(
            (promises: Array<Promise<boolean>>) => {
              Promise.all(promises)
                .then(
                  (values) => {
                    if (values.every((value) => value === true)) {
                      //logger.out.info("Prime guard, can activate values=", values);
                      this.primed = true;
                      this.waitPrimedSet.resolve(true);
                      resolve(true);
                    } else {
                      this.primed = false;
                      this.waitPrimedSet.resolve(false);
                      resolve(false);
                    }
                  },
                  (rejection) => {
                    //logger.out.info("Prime guard, can activate reject=", rejection);
                    this.waitPrimedSet.resolve(false);
                    resolve(false);
                  },
                )
                .catch((reason) => {
                  //logger.out.error("ERROR: Prime guard");
                  this.waitPrimedSet.resolve(false);
                  resolve(false);
                });
            },
            (err) => {
              this.waitPrimedSet.resolve(false);
              resolve(false);
            },
          );
        } catch (err) {
          logger.out.info("err", err);
          this.waitPrimedSet.resolve(false);
          resolve(false);
        }
      });
    }
  }

  public waitPrimed(): Promise<boolean> {
    return this.waitPrimedSet.get();
  }
  /**********************************************************************/
  /* PRIVATE METHODS */
  private prepareServicePromises(): Promise<Array<Promise<boolean>>> {
    return new Promise((rootResolve, rootReject) => {
      let promiseServiceArray = [
        new Promise<boolean>((res) => {
          setImmediate(() => {
            this.config && this.config.debug
              ? logger.out.info("INFO: PrimeService.prime() Authorized=" + true)
              : "";
            this.updateProgress("Log In Successful ", true);
            res(true);
          });
        }),

        new Promise<boolean>((res, rej) => {
          this._cubiqAccountService.isPrimed().then(
            (resolve: boolean) => {
              this.config && this.config.debug
                ? logger.out.info(
                    "INFO: PrimeService.prime() AccountPromiseLookupService primed! resolve=" +
                      resolve,
                  )
                : "";
              this.updateProgress("Loading Accounts ", resolve);
              res(resolve);
            },
            (reject) => {
              this.config && this.config.debug
                ? logger.out.error(
                    "ERROR: PrimeService.prime() AccountPromiseLookupService reject=",
                    reject,
                  )
                : "";
              this.updateProgress("Loading Accounts", false);
              rej(reject);
            },
          );
        }),
        new Promise<boolean>((res, rej) => {
          this._cubiqCcyService.isPrimed().then(
            (resolve: boolean) => {
              this.config && this.config.debug
                ? logger.out.info(
                    "INFO: PrimeService.prime() CcyPromiseLookupService primed! resolve=" + resolve,
                  )
                : "";
              this.updateProgress("Loading Currencies", resolve);
              res(resolve);
            },
            (reject) => {
              this.config && this.config.debug
                ? logger.out.error(
                    "ERROR: PrimeService.prime() CcyPromiseLookupService reject=",
                    reject,
                  )
                : "";
              this.updateProgress("Loading Currencies", false);
              rej(reject);
            },
          );
        }),

        new Promise<boolean>((res, rej) => {
          this._cubiqCcyPairService.isPrimed().then(
            (resolve: boolean) => {
              this.config && this.config.debug
                ? logger.out.info(
                    "INFO: PrimeService.prime() CcyPairPromiseLookupService primed! resolve=" +
                      resolve,
                  )
                : "";
              this.updateProgress("Loading Currency Pairs", resolve);
              res(resolve);
            },
            (reject) => {
              this.config && this.config.debug
                ? logger.out.error(
                    "ERROR: PrimeService.prime() CcyPairPromiseLookupService reject=",
                    reject,
                  )
                : "";
              this.updateProgress("Loading Currency Pairs", false);
              rej(reject);
            },
          );
        }),

        new Promise<boolean>((res, rej) => {
          this._cubiqTraderGroupService.isPrimed().then(
            (resolve: boolean) => {
              this.config && this.config.debug
                ? logger.out.info(
                    "INFO: PrimeService.prime() TraderGroupPromiseLookupService primed! resolve=" +
                      resolve,
                  )
                : "";
              this.updateProgress("Loading Trader Groups", resolve);
              res(resolve);
            },
            (reject) => {
              this.config && this.config.debug
                ? logger.out.error(
                    "ERROR: PrimeService.prime() TraderGroupPromiseLookupService reject=",
                    reject,
                  )
                : "";
              this.updateProgress("Loading Trader Groups", false);
              rej(reject);
            },
          );
        }),

        new Promise<boolean>((res, rej) => {
          this._cubiqSalesGroupService.isPrimed().then(
            (resolve: boolean) => {
              this.config && this.config.debug
                ? logger.out.info(
                    "INFO: PrimeService.prime() SalesGroupPromiseLookupService primed! resolve=" +
                      resolve,
                  )
                : "";
              this.updateProgress("Loading Sales Groups", resolve);
              res(resolve);
            },
            (reject) => {
              this.config && this.config.debug
                ? logger.out.error(
                    "ERROR: PrimeService.prime() SalesGroupPromiseLookupService reject=",
                    reject,
                  )
                : "";
              this.updateProgress("Loading Sales Groups", false);
              rej(reject);
            },
          );
        }),

        new Promise<boolean>((res, rej) => {
          this._cubiqOrderDataService.isPrimed().then(
            (resolve: boolean) => {
              this.config && this.config.debug
                ? logger.out.info(
                    "INFO: PrimeService.prime() OrderDataPromiseLookupService primed! resolve=" +
                      resolve,
                  )
                : "";
              this.updateProgress("Loading Orders", resolve);
              res(resolve);
            },
            (reject) => {
              this.config && this.config.debug
                ? logger.out.error(
                    "ERROR: PrimeService.prime() OrderDataPromiseLookupService reject=",
                    reject,
                  )
                : "";
              this.updateProgress("Loading Orders", false);
              rej(reject);
            },
          );
        }),

        new Promise<boolean>((res, rej) => {
          this._cubiqClientService.isPrimed().then(
            (resolve: boolean) => {
              this.config && this.config.debug
                ? logger.out.info(
                    "INFO: PrimeService.prime() ClientPromiseLookupService primed! resolve=" +
                      resolve,
                  )
                : "";
              this.updateProgress("Loading Clients", resolve);
              res(resolve);
            },
            (reject) => {
              this.config && this.config.debug
                ? logger.out.error(
                    "ERROR: PrimeService.prime() ClientPromiseLookupService reject=",
                    reject,
                  )
                : "";
              this.updateProgress("Loading Clients", false);
              rej(reject);
            },
          );
        }),

        new Promise<boolean>((res, rej) => {
          this._systemConfigService.canViewOrderBlotters().then(
            (visible) => {
              if (!visible) {
                // this.updateProgress( 'Loading Order Blotter (unused)' , true);
                this.skipProgress();
                res(true);
                return;
              }

              this._blotterOrdersService.isPrimed().then(
                (resolve) => {
                  this.config && this.config.debug
                    ? logger.out.info(
                        "INFO: PrimeService.prime() BfxLadderBlotterOrdersService primed! resolve=" +
                          resolve,
                      )
                    : "";
                  this.updateProgress("Loading Order Blotter ", resolve);
                  res(resolve);
                },
                (reject) => {
                  this.config && this.config.debug
                    ? logger.out.error(
                        "ERROR: PrimeService.prime() BfxLadderBlotterOrdersService reject=",
                        reject,
                      )
                    : "";
                  this.updateProgress("Loading Order Blotter", false);
                  rej(reject);
                },
              );
            },
            (reject) => {
              this.updateProgress("Loading Order Blotter", false);
              rej(reject);
            },
          );
        }),

        new Promise<boolean>((res, rej) => {
          this._systemConfigService.canViewTradesBlotters().then(
            (visible) => {
              if (!visible) {
                // this.updateProgress( 'Loading Trade Blotter (unused)' , true);
                this.skipProgress();
                res(true);
                return;
              }

              this._tradeBlotterService.isPrimed().then(
                (resolve) => {
                  this.config && this.config.debug
                    ? logger.out.info(
                        "INFO: PrimeService.prime() BfxTradeBlotterService primed! resolve=" +
                          resolve,
                      )
                    : "";
                  this.updateProgress("Loading Trade Blotter", resolve);
                  res(resolve);
                },
                (reject) => {
                  this.config && this.config.debug
                    ? logger.out.error(
                        "ERROR: PrimeService.prime() BfxTradeBlotterService reject=",
                        reject,
                      )
                    : "";
                  this.updateProgress("Loading Trade Blotter", false);
                  rej(reject);
                },
              );
            },
            (reject) => {
              this.updateProgress("Loading Trade Blotter", false);
              rej(reject);
            },
          );
        }),

        new Promise<boolean>((res, rej) => {
          this._systemConfigService.canViewDealerInterventionBlotters().then(
            (visible) => {
              if (!visible) {
                // this.updateProgress( 'Loading Intervention Blotter  (unused)' , true);
                this.skipProgress();
                res(true);
                return;
              }

              this._interventionBlotterService.isPrimed().then(
                (resolve) => {
                  this.config && this.config.debug
                    ? logger.out.info(
                        "INFO: PrimeService.prime() BfxInterventionBlotterService primed! resolve=" +
                          true,
                      )
                    : "";
                  this.updateProgress("Loading Intervention Blotter", resolve);
                  res(resolve);
                },
                (reject) => {
                  this.config && this.config.debug
                    ? logger.out.error(
                        "ERROR: PrimeService.prime() BfxInterventionBlotterService reject=",
                        reject,
                      )
                    : "";
                  this.updateProgress("Loading Intervention Blotter", false);
                  rej(reject);
                },
              );
            },
            (reject) => {
              this.updateProgress("Loading Intervention Blotter", false);
              rej(reject);
            },
          );
        }),

        new Promise<boolean>((res, rej) => {
          this._systemConfigService.canViewConnectionMonitor().then(
            (visible) => {
              if (!visible) {
                this.updateProgress("Loading Connection Monitor ", true);
                res(true);
                return;
              }

              this._connectionMonitorService.isPrimed().then(
                (resolve: boolean) => {
                  this.config && this.config.debug
                    ? logger.out.info(
                        "INFO: PrimeService.prime() Connection monitor primed! resolve=" + true,
                      )
                    : "";
                  this.updateProgress("Loading Connection Monitor", resolve);
                  res(resolve);
                },
                (reject) => {
                  this.config && this.config.debug
                    ? logger.out.error(
                        "ERROR: PrimeService.prime() Connection monitor reject=",
                        reject,
                      )
                    : "";
                  this.updateProgress("Loading Connection Monitor", false);
                  rej(reject);
                },
              );
            },
            (reject) => {
              this.updateProgress("Loading Connection Monitor ", false);
              rej(reject);
            },
          );
        }),

        // new Promise<boolean>((res, rej) => {
        // 	this._systemConfigService.canViewScratchPad().then((visible) => {
        // 		if (!visible) {
        // 			// this.updateProgress( 'Loading Scratch Pad  (unused)' , true);
        // 			this.skipProgress();
        // 			res(true);
        // 			return;
        // 		}

        // 		this._scratchPadOrdersService.isPrimed().then(
        // 			(resolve) => {
        // 				(this.config && this.config.debug ? logger.out.info('INFO: PrimeService.prime() BfxScratchPadService primed! resolve=' + true): '');
        // 				this.updateProgress( 'Loading Scratch Pad Blotter' , resolve);
        // 				res(resolve);
        // 			},
        // 			(reject) => {
        // 					(this.config && this.config.debug ? logger.out.error('ERROR: PrimeService.prime() BfxScratchPadService reject=', reject): '');
        // 				this.updateProgress( 'Loading Scratch Pad', false);
        // 				rej(reject);
        // 			});
        // 	}, (reject) => {
        // 		this.updateProgress( 'Loading Scratch Pad', false);
        // 		rej(reject);
        // 	});
        // }),

        new Promise<boolean>((res, rej) => {
          this._translateService.get(ASYNC_PRIME_KEY).subscribe({
            next: (i18n) => {
              // i18n loader is async.
              // allow loader to complete before TranslateService.instant() hit
              if (i18n === ASYNC_PRIME_VALUE) {
                this.config && this.config.debug
                  ? logger.out.info("INFO: PrimeService.prime() i18n primed! resolve=" + true)
                  : "";
                this.updateProgress("Logging In", true);
                res(true);
              } else {
                let e = Error("PrimeService: Failed to prime required translation.");
                this.config && this.config.debug
                  ? logger.out.error("ERROR: PrimeService.prime() i18n reject=", e)
                  : "";
                this.updateProgress("Logging In", false);
                rej(e);
              }
            },
            error: (reject) => {
              this.updateProgress("Logging In", false);
              rej(reject);
            },
          });
        }),
      ];

      // temp - avoid 100% on start
      this.progress.total = promiseServiceArray.length;

      // Conditional promises
      Promise.all([this._systemConfigService.areBenchmarksEnabled()])
        .then((values) => {
          if (values[0]) {
            // if benchmarks are enabled add the promise
            let bmarkPromise = new Promise<boolean>((res, rej) => {
              this._benchmarkLookupService.isPrimed().then(
                (resolve) => {
                  this.config && this.config.debug
                    ? logger.out.info(
                        "INFO: PrimeService.prime() BenchmarkDataPrimaryLookupService primed! resolve=" +
                          resolve,
                      )
                    : "";
                  this.updateProgress("Loading Benchmark Orders", resolve);
                  res(resolve);
                },
                (reject) => {
                  this.config && this.config.debug
                    ? logger.out.error(
                        "ERROR: PrimeService.prime() BenchmarkDataPrimaryLookupService reject=",
                        reject,
                      )
                    : "";
                  this.updateProgress("Loading Benchmark Orders", false);
                  rej(reject);
                },
              );
            });
            promiseServiceArray.push(bmarkPromise);
          } else {
            logger.out.info("INFO: BMARK: Benchmarks Orders are DISABLED!");
          }
        })
        .finally(() => {
          this.progress.total = promiseServiceArray.length;

          this.config && this.config.debug
            ? logger.out.info(
                "PrimeService.prepareServicePromises() serviceArray=",
                promiseServiceArray,
              )
            : "";
          rootResolve(promiseServiceArray);
        });
    });
  }

  /**
   * call when due to configration prime will no longer occur
   *
   * never dispatches
   */
  private skipProgress(): void {
    this.progress.skipped++;
  }

  private updateProgress(_serviceName: string, _resolve: boolean): void {
    let command: string;
    if (!_resolve) {
      this.progress.error++;
      command = "error";
    } else {
      this.progress.primed++;
      command = "primed";
    }
    let payload = {
      service: _serviceName,
      primed: this.progress.primed,
      error: this.progress.error,
      total: this.progress.total - this.progress.skipped,
    };

    this.dispatchPrimeControlEvent(command, payload);
  }

  private dispatchPrimeControlEvent(_cmd: string, _payload: any): void {
    this._primeControlSource.next({ cmd: _cmd, payload: _payload });
  }
}
